/* tslint:disable */
/* eslint-disable */
/**
 * 80s Conservation Club REST API
 * 80s Conservation Club REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: graham@matthewsapps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Account } from './Account';
import {
    AccountFromJSON,
    AccountFromJSONTyped,
    AccountToJSON,
} from './Account';

/**
 * 
 * @export
 * @interface GetAccount200Response
 */
export interface GetAccount200Response {
    /**
     * 
     * @type {Account}
     * @memberof GetAccount200Response
     */
    data: Account;
}

/**
 * Check if a given object implements the GetAccount200Response interface.
 */
export function instanceOfGetAccount200Response(value: object): value is GetAccount200Response {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function GetAccount200ResponseFromJSON(json: any): GetAccount200Response {
    return GetAccount200ResponseFromJSONTyped(json, false);
}

export function GetAccount200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAccount200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': AccountFromJSON(json['data']),
    };
}

export function GetAccount200ResponseToJSON(value?: GetAccount200Response | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': AccountToJSON(value['data']),
    };
}

